export const iconFontAwesomeEducationAtom = (
	<i className="fa-solid fa-atom"></i>
);
